import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

/**
 * AnimatedInput Component
 * -----------------------
 * Props:
 * - label: string (label text)
 * - type: 'text' | 'email' | 'password'
 * - delayStep: number (stagger delay between letter animations)
 * - showToggle: boolean (adds show/hide icon for password fields)
 */
export default function AnimatedInput({
  label,
  type = 'text',
  delayStep = 50,
  showToggle = false,
  value,
  onChange,
}) {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const inputType =
    type === 'password' && showToggle && showPassword ? 'text' : type;

  const letters = label.split('');

  return (
    <div className='relative w-full mt-4'>
      <input
        type={inputType}
        required
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        className='peer w-full bg-transparent border-0 border-b border-white/30 focus:border-white 
                   text-white placeholder-transparent py-3 text-base focus:outline-none transition-all duration-300'
      />
      <label className='absolute left-0 top-3 pointer-events-none'>
        {letters.map((char, index) => (
          <span
            key={index}
            className={`inline-block text-lg text-gray-400 transition-all duration-300 ${focused || value
                ? 'translate-y-[-25px] text-white text-sm'
                : ''
              }`}
            style={{
              transitionDelay: `${index * delayStep}ms`,
              minWidth: '6px',
            }}
          >
            {char}
          </span>
        ))}
      </label>

      {showToggle && type === 'password' && (
        <button
          type='button'
          onClick={() => setShowPassword(!showPassword)}
          className='absolute right-0 top-3 text-white/70 hover:text-white transition-colors'
        >
          {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </button>
      )}
    </div>
  );
}
